module.exports = __webpack_public_path__ + "media/images/youtube-fb6403755fa8a628e4ec2329667966b1.svg";